/* Inkfold ebook sample-chapter modal */
(function () {
  const modal = document.querySelector("[data-vs-sample-modal]");
  if (!modal) return;

  const openBtn = document.querySelector("[data-vs-sample-open]");
  const closeEls = modal.querySelectorAll("[data-vs-sample-close]");
  const panel = modal.querySelector(".vs-sample-modal__panel");
  let lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = "hidden";
    document.addEventListener("keydown", onKeydown);
    panel.focus();
  }

  function close() {
    modal.hidden = true;
    document.documentElement.style.overflow = "";
    document.removeEventListener("keydown", onKeydown);
    if (lastFocus && typeof lastFocus.focus === "function") {
      lastFocus.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === "Escape") close();
  }

  if (openBtn) openBtn.addEventListener("click", open);
  closeEls.forEach((el) => el.addEventListener("click", close));
})();
